(function($, undefined) {
	
	'use strict';
	var utils = Fw.component.models().utils;

	var init = function (page) {
		var currPage = $(page);
		
		$('.fancytitle-setting-no-image-btn').click(function() {
			$(this).parents(".fancytitle-wrapper").css('background', "#01308A");
			var localId = $(this).data('localId');
			var key = "fancytitle-image-" + localId;
			var value = "";
			
			utils.updateLabelLangs(key, value, 'en,fr');
		});
		
	};
	
	var fancytitle = Fw.modules.export('fancytitle', {
		init: init
	});
	
})(jQuery);

